import React, { useContext, useEffect, useRef, useState } from 'react';
import logo from '../media/kidoriseLogo.png';
import { Link, useNavigate } from 'react-router-dom';
import LogContext from '../context/LogContext';
import useAuth from '../hooks/useAuth';
import axios from 'axios';
import { homeScroll } from '../smoothScroll';
import slugify from '../utils/slugify';
import HeaderTop from './ui/HeaderTop';

const backendUrl = process.env.REACT_APP_BACKEND_URL;
const adminUrl = process.env.REACT_APP_ADMIN_BACKEND_URL; // ✅ works

axios.defaults.credentials = true
const Header = () => {

    const { isAuthenticated, loading } = useAuth();
    const [headerCart, setHeaderCart] = useState();
    const [email, setEmail] = useState();
    const [products, setProducts] = useState([]);
    const [totalValue, setTotalValue] = useState();
    const [search, setSearch] = useState('');
    const [searchResult, setSearchResult] = useState([]);
    const [collections, setCollections] = useState([]);
    const [isSearch, setIsSearch] = useState();
    const category = useContext(LogContext);
    const navigate = useNavigate();

    const searchHandler = async () => {
        try {
            const response = await fetch(`${backendUrl}/searchResult`, {
            method: "POST",
            headers: {
                "content-type": "application/json"
            },
            body: JSON.stringify({ search })
        });
            if (response.ok) {
                const data = await response.json();
                setSearchResult(data["products"]);
            }
        } catch (error) {
            console.log("some error occured while searching")
        }
    }

    const handleLogout = async () => {
        try {
            await axios.get(`${backendUrl}/logout`, {
                withCredentials: true // Correct key to include cookies
            });

            navigate('/', { replace: true });

            // Optional: Force reload to clear any lingering app state
            setTimeout(() => {
                window.location.reload();
            }, 0);

        } catch (error) {
            console.error("Logout failed:", error);
            alert("Logout failed. Please try again.");
        }
    };
    const addToCartHandler = async (itemID) => {
        try {
            if (!category.user.email) {
                navigate('/login');
            }
            else if (products.filter(items => items.productID === itemID).length != 0) {
                return
            }
            else {
                const response = await fetch(`${backendUrl}/cartHandler`, {
                    method: "POST",
                    headers: {
                        "content-type": "application/json"
                    },
                    body: JSON.stringify({ "email": category.user.email, "itemID": itemID })
                });
                if (response.ok) {
                    category.updateCart(itemID)
                }

            }
        } catch (error) {
            console.log("Some error occured", error)
        }

    }

    const cartUpdate = async () => {
        try {
            const response = await fetch(`${backendUrl}/cartData`, {
                method: "POST",
                headers: {
                    "content-type": "application/json"
                },
                body: JSON.stringify({ email: email })
            });
            if (response.ok) {
                const productArray = await response.json();
                if (productArray.cartItems) {
                    setProducts(productArray.cartItems);
                }
            }
            else {
                console.log("Can't retrieve data from the user collections in the database");
            }
        } catch (error) {
            console.error("Error fetching cart data:");
        }
    }
    const getCollections = async () => {
        try {
            const response = await fetch(`${adminUrl}/getCollections`, {
            method: 'GET',
            headers: {
                "content-type": "application/json"
            }
        });
            if (response.ok) {
                const data = await response.json();
                setCollections(data);
            }
            else {
                console.log("cant get the collections data")
            }
        } catch (error) {
            console.log("error occured getting collections data", error)
        }
    }

    const navRef = useRef(null);
    const hTopRef = useRef(null);



    useEffect(() => {
        let timeoutId = null;

        const handleScroll = () => {
            if (!navRef.current) return;
            if (!hTopRef.current) return
            if (window.scrollY > 1) {
                navRef.current.classList.add('current');
                // hTopRef.current.classList.add('hide')
                // Clear previous timeout if any
                if (timeoutId) clearTimeout(timeoutId);

                // Delay adding fixed class
                timeoutId = setTimeout(() => {
                    navRef.current?.classList.add('fixed');
                }, 10);
            } else {
                // Clear timeout if scrolling back to top before timeout
                if (timeoutId) clearTimeout(timeoutId); {
                    navRef.current.classList.remove('fixed');
                    // hTopRef.current.classList.add('hide')
                    // navRef.current.classList.remove('current');

                }

            }
        };

        window.addEventListener('scroll', handleScroll, { passive: true });

        return () => {
            window.removeEventListener('scroll', handleScroll);
            if (timeoutId) clearTimeout(timeoutId); // cleanup timeout
        };
    }, []);



    const searchRef = useRef(null);
    useEffect(() => {
        if (searchResult.length) {
            searchRef.current.classList.add('show')
        }
        else {
            searchRef.current.classList.remove('show')
        }
    }, [searchResult])

    useEffect(() => {
        getCollections();
    }, [])


    useEffect(() => {
        if (category.user) {
            setEmail(category.user.email);
        }
    }, [category.user]);

    useEffect(() => {
        if (email !== undefined) {
            cartUpdate();
        }
    }, [email]);
    useEffect(() => {
        function sum(total, element) {
            return total + (parseFloat(element.quantity)) * (parseFloat(element.pricing.offerPrice))
        }
        const totalValue = products.reduce(sum, 0);
        setTotalValue(totalValue);
    }, [products]);

    useEffect(() => {
        cartUpdate();
    }, [category.cart]);

    useEffect(() => {
        localStorage.removeItem("filter");
    }, [window.location.pathname])

    return (
        <header id="home" className="welcome-hero" style={{ maxWidth: '100%', overflowX: 'hidden' }} >

            {window.location.pathname === '/' && <div id="header-carousel" className="carousel slide carousel-fade" data-ride="carousel" data-interval="3000" data-pause="false">
                {/* .carousel-indicator */}
                <ol className="carousel-indicators">
                    <li data-target="#header-carousel" data-slide-to="0" className="active"><span className="small-circle"></span></li>
                    <li data-target="#header-carousel" data-slide-to="1"><span className="small-circle"></span></li>
                    <li data-target="#header-carousel" data-slide-to="2"><span className="small-circle"></span></li>
                </ol>{/* /ol*/}
                {/* .carousel-indicator */}

                {/* .carousel-inner */}
                <div className="carousel-inner" role="listbox">
                    {/* .item */}
                    <div className="item active">
                        <div className="single-slide-item slide1">
                            <div className="container">
                                <div className="welcome-hero-content">
                                    <div className="row">
                                        <div className="col-sm-7">
                                            <div className="single-welcome-hero carousel-content">
                                                <div className="welcome-hero-txt">
                                                    <h4>Nest Bag</h4>
                                                    <h2>Baby Organic Cotton  Sleeping cum Carrying Nest Bag</h2>
                                                    <p>
                                                        Our baby sleeping bag carrier nests are thoughtfully made of an organic cotton outer layer, filled with 40% anti-allergic polyfiber and 60% organic cotton. This cozy blend offers superior softness and comfort for your baby on the go. The breathable organic cotton layer ensures optimal airflow, helping regulate body temperature and keeping your little one snug all day long.                                                    </p>
                                                    <div className="packages-price">
                                                        <p>
                                                            &#8377; 350.00
                                                            <del>&#8377; 500.00</del>
                                                        </p>
                                                    </div>
                                                    <button className="btn-cart welcome-add-cart"
                                                        onClick={(e) => { addToCartHandler("68cc39d4e1cc23a06d2cf974") }}
                                                    >
                                                        <span className="lnr lnr-plus-circle"></span>
                                                        add <span>to</span> cart
                                                    </button>
                                                    <button className="btn-cart welcome-add-cart welcome-more-info"
                                                        onClick={(e) => {
                                                            navigate(`/products/Baby Cotton Sleeping Bag`);
                                                            homeScroll();
                                                            localStorage.setItem('currentProduct', "Baby Cotton Sleeping Bag");
                                                            category.updateProduct("Baby Cotton Sleeping Bag")
                                                        }}
                                                    >
                                                        more info
                                                    </button>
                                                </div>{/*/.welcome-hero-txt*/}
                                            </div>{/*/.single-welcome-hero*/}
                                        </div>{/*/.col*/}
                                        <div className="col-sm-5">
                                            <div className="single-welcome-hero">
                                                <div className="welcome-hero-img">
                                                    <img src="/assets/images/slider/slider1.png" alt="slider image" />
                                                </div>{/*/.welcome-hero-txt*/}
                                            </div>{/*/.single-welcome-hero*/}
                                        </div>{/*/.col*/}
                                    </div>{/*/.row*/}
                                </div>{/*/.welcome-hero-content*/}
                            </div>{/* /.container*/}
                        </div>{/* /.single-slide-item*/}

                    </div>{/* /.item .active*/}

                    <div className="item">
                        <div className="single-slide-item slide2">
                            <div className="container">
                                <div className="welcome-hero-content">
                                    <div className="row">
                                        <div className="col-sm-7">
                                            <div className="single-welcome-hero carousel-content">
                                                <div className="welcome-hero-txt">
                                                    <h4>Mosquito Net</h4>
                                                    <h2>Baby Organic Cotton Foldable Mosquito Net Bedding</h2>
                                                    <p>
                                                        Protect your baby from mosquitoes and other insects with the Organic Cotton Foldable Mosquito Net Bedding, a perfect blend of comfort and safety. This is an organic cotton muslin fabric bedding set that will provide comfort for your little one while securely protecting against bugs with a breathable barrier. It is made of extra soft and light muslin to make your baby comfortable while sleeping.
                                                    </p>
                                                    <div className="packages-price">
                                                        <p>
                                                            ₹ 290.00
                                                            <del>₹ 450.00</del>
                                                        </p>
                                                    </div>
                                                    <button className="btn-cart welcome-add-cart"
                                                        onClick={(e) => { addToCartHandler("68cc3c93e1cc23a06d2cfa46") }}
                                                    >
                                                        <span className="lnr lnr-plus-circle"></span>
                                                        add <span>to</span> cart
                                                    </button>
                                                    <button className="btn-cart welcome-add-cart welcome-more-info"
                                                        onClick={(e) => {
                                                            navigate(`/products/Baby Organic Cotton Foldable Mosquito Net Bedding- Elephant`);
                                                            homeScroll();
                                                            localStorage.setItem('currentProduct', "Baby Organic Cotton Foldable Mosquito Net Bedding- Elephant");
                                                            category.updateProduct("Baby Organic Cotton Foldable Mosquito Net Bedding- Elephant")
                                                        }}
                                                    >
                                                        more info
                                                    </button>
                                                </div>{/*/.welcome-hero-txt*/}
                                            </div>{/*/.single-welcome-hero*/}
                                        </div>{/*/.col*/}
                                        <div className="col-sm-5">
                                            <div className="single-welcome-hero">
                                                <div className="welcome-hero-img">
                                                    <img src="/assets/images/slider/slider2.png" alt="slider image" />
                                                </div>{/*/.welcome-hero-txt*/}
                                            </div>{/*/.single-welcome-hero*/}
                                        </div>{/*/.col*/}
                                    </div>{/*/.row*/}
                                </div>{/*/.welcome-hero-content*/}
                            </div>{/* /.container*/}
                        </div>{/* /.single-slide-item*/}

                    </div>{/* /.item .active*/}

                    <div className="item">
                        <div className="single-slide-item slide3">
                            <div className="container">
                                <div className="welcome-hero-content">
                                    <div className="row">
                                        <div className="col-sm-7">
                                            <div className="single-welcome-hero carousel-content">
                                                <div className="welcome-hero-txt">
                                                    <h4>Baby Pillow</h4>
                                                    <h2>Hopop Cat Baby Mustard Pillow Mutlicolor-For Infants</h2>
                                                    <p>
                                                        Mustard Seeds Pillow, designed for newborns up to 12 months to ensure your baby’s comfort and well-being. Crafted from premium materials, it offers essential support for your baby’s developing head and neck. The pillow features a durable and safe design, with a 100% cotton outer cover that is gentle on delicate skin, providing a soft and cozy surface.
                                                    </p>
                                                    <div className="packages-price">
                                                        <p>
                                                            ₹ 100.00
                                                            <del>₹ 150.00</del>
                                                        </p>
                                                    </div>
                                                    <button className="btn-cart welcome-add-cart"
                                                        onClick={(e) => { addToCartHandler("68cc3d56e1cc23a06d2cfb2e") }}
                                                    >
                                                        <span className="lnr lnr-plus-circle"></span>
                                                        add <span>to</span> cart
                                                    </button>
                                                    <button className="btn-cart welcome-add-cart welcome-more-info"
                                                        onClick={(e) => {
                                                            navigate(`/products/Hopop Cat Baby Mustard Pillow Mutlicolor-For Infants`);
                                                            homeScroll();
                                                            localStorage.setItem('currentProduct', "Hopop Cat Baby Mustard Pillow Mutlicolor-For Infants");
                                                            category.updateProduct("Hopop Cat Baby Mustard Pillow Mutlicolor-For Infants")
                                                        }}
                                                    >
                                                        more info
                                                    </button>
                                                </div>{/*/.welcome-hero-txt*/}
                                            </div>{/*/.single-welcome-hero*/}
                                        </div>{/*/.col*/}
                                        <div className="col-sm-5">
                                            <div className="single-welcome-hero">
                                                <div className="welcome-hero-img">
                                                    <img src="/assets/images/slider/slider3.png" alt="slider image" />
                                                </div>{/*/.welcome-hero-txt*/}
                                            </div>{/*/.single-welcome-hero*/}
                                        </div>{/*/.col*/}
                                    </div>{/*/.row*/}
                                </div>{/*/.welcome-hero-content*/}
                            </div>{/* /.container*/}
                        </div>{/* /.single-slide-item*/}

                    </div>{/* /.item .active*/}
                </div>{/* /.carousel-inner*/}

            </div>
            }{/*/#header-carousel*/}

            {/* top-area Start */}
            <div className="top-area">
                <div className="header-area navbarr" ref={navRef}>
                    <div className='header-top'><HeaderTop /></div>

                    {/* Start Navigation */}
                    <nav ref={hTopRef} className=" navbar-default bootsnav  navbar-sticky navbar-scrollspy" data-minus-value-desktop="70" data-minus-value-mobile="55" data-speed="1000">

                        {/* Start Top Search */}
                        <div className="top-search" id='top-search'>
                            <div className="container">
                                <div className="input-group" style={{ width: '100%' }}>
                                    <span className="input-group-addon" style={{ width: '100%' }}><i className="fa fa-search"></i><input type="text" className="" placeholder="Search" value={search} onChange={(e) => { setSearch(e.target.value); searchHandler() }} onFocus={() => { setIsSearch(true) }} /></span>

                                    <span className="input-group-addon close-search"
                                        // onClick={() => document.getElementById('top-search').style.display = 'none'}
                                        onClick={() => {
                                            const el = document.getElementById('top-search');
                                            el.classList.toggle('show');
                                            hTopRef.current.classList.toggle('search-open');
                                            searchRef.current.classList.remove('show');
                                            setSearch('')
                                        }}
                                    ><i className="fa fa-times"></i></span>
                                </div>
                            </div>
                            <ul className='search-result' ref={searchRef} >
                                {(search) &&
                                    searchResult.map((product) => (
                                        <li className=''>
                                            <div style={{ display: "flex", paddingTop: '1rem', paddingBottom: '1rem' }}>
                                                <img className='img' src={`${adminUrl}/uploads/products/${product.images[0].preview}`} alt="" onClick={() => { localStorage.setItem('currentProduct', product.title); category.updateProduct(product.title); navigate('/products'); window.location.reload() }} />
                                                <div className='details'>
                                                    <p className='name'>
                                                        {product.title}
                                                    </p>
                                                    <p className='ratings'>
                                                        {product.productRatings.ratings >= 0 && <i class="fa-solid fa-star"></i>}
                                                        {product.productRatings.ratings >= 0 && <i class="fa-solid fa-star"></i>}
                                                        {product.productRatings.ratings >= 0 && <i class="fa-solid fa-star"></i>}
                                                        {product.productRatings.ratings >= 0 && <i class="fa-solid fa-star"></i>}
                                                        {product.productRatings.ratings >= 0 && <i class="fa-solid fa-star"></i>}
                                                    </p>
                                                </div>
                                            </div>
                                        </li>

                                    ))
                                }
                            </ul>
                        </div>
                        {/* End Top Search */}

                        <div className="container">
                            {/* Start Atribute Navigation */}
                            <div className="attr-nav">
                                <ul className=''>
                                    <li className="search" >
                                        <Link className='search-icon'
                                            onClick={() => {
                                                const el = document.getElementById('top-search');
                                                el.classList.toggle('show');
                                                hTopRef.current.classList.toggle('search-open');
                                            }}
                                        ><span className="lnr lnr-magnifier"></span></Link>
                                    </li>{/*/.search*/}
                                    <li >
                                        <Link className="dropdown" to="#" onClick={(e) => e.preventDefault()} >
                                            <Link className="dropdown-toggle" data-toggle="dropdown" >
                                                <span className="lnr lnr-cog header-cog"></span>
                                                <span className="badge badge-bg-1"></span>
                                            </Link>
                                            <ul className="dropdown-menu one cart-list s-cate">
                                                <li className="single-cart-list">
                                                    <div className='cart-list-text' style={{ display: 'flex' }}>
                                                        <i className="fa-solid fa-user"></i>
                                                        <h5 className='head1' onClick={() => { !category.user.email ? navigate('/login') : navigate('/account/personal-info'); homeScroll() }}>{category.user.email ? category.user.firstName ? category.user.firstName : "Hello" : 'Profile'}</h5>
                                                    </div>

                                                </li>{/*/.single-cart-list */}
                                                <li className="single-cart-list">
                                                    <div className='cart-list-text' style={{ display: 'flex' }}>
                                                        <i className="fa-solid fa-bag-shopping"></i>
                                                        <h5 className='head2' onClick={() => { category.user.email ? navigate('/account/orders') : navigate('/login'); homeScroll() }}>My Orders</h5>
                                                    </div>
                                                </li>{/*/.single-cart-list */}
                                                <li className="single-cart-list">
                                                    <div className='cart-list-text' style={{ display: 'flex' }}>
                                                        <i className="fa-solid fa-heart"></i>
                                                        <h5 className='head3' onClick={() => { category.user.email ? navigate('/account/wishlist') : navigate('/login'); homeScroll() }}>My Whishlist</h5>
                                                    </div>
                                                </li>{/*/.single-cart-list */}
                                                <li className="single-cart-list">
                                                    <div className='cart-list-text' style={{ display: 'flex' }}>
                                                        <i className="fa-solid fa-right-from-bracket"></i>
                                                        {category.user.email ? <h5 onClick={handleLogout} className='head4'>Logout</h5> : <h5 onClick={() => { navigate('/login') }} className='head4'>Sign In</h5>}
                                                    </div>
                                                </li>
                                            </ul>
                                        </Link>
                                    </li>
                                    <li>
                                        {/* to make dropdown add a dropdown to className */}
                                        <Link className="dropdown" onClick={() => { category.user.email ? navigate("/cart") : navigate('/login') }}>
                                            {/* add dropdown-toggle to className  and add dropdown in data-toggle*/}
                                            <Link className="dropdown-toggle" data-toggle="" >
                                                <span className="lnr lnr-cart header-cart"></span>
                                                {products[0] != -1 && <span className="badge badge-bg-1 header-badge">{products.length}</span>}
                                            </Link>
                                            <ul className="dropdown-menu two cart-list s-cate">
                                                {!products.length ?
                                                    <li className='single-cart-list'>
                                                        <div className="cart-list-txt">
                                                            <h6><Link to="/">Cart is Empty</Link></h6>
                                                            <p></p>
                                                        </div>
                                                    </li>
                                                    :
                                                    products.length && products.map((product) => (
                                                        <li key={product._id} className="single-cart-list">
                                                            <Link to="#" className="photo"><img src={`${adminUrl}/uploads/products/${product.images && product.images[0].preview}`} className="cart-thumb" alt="image" /></Link>
                                                            <div className="cart-list-txt">
                                                                <h6><Link to="/"> {product.title}</Link></h6>
                                                                <p>{product.quantity} x - <span className="price">&#8377; {product.pricing && product.pricing.offerPrice}</span></p>
                                                            </div>
                                                            <div className="cart-close">
                                                                <span className="lnr lnr-cross"></span>
                                                            </div>
                                                        </li>
                                                    ))
                                                }
                                                <li className="total">
                                                    <span>Total: ₹ {totalValue}</span>
                                                    <button className="btn-cart pull-right" onClick={() => { category.user.email ? navigate('/cart') : navigate('/login'); homeScroll() }} style={{ padding: '1rem 1rem' }}>view cart</button>
                                                </li>
                                            </ul>
                                        </Link>
                                    </li>{/*/.dropdown*/}
                                </ul>
                            </div>{/*/.attr-nav*/}
                            {/* End Atribute Navigation */}

                            {/* Start Header Navigation */}
                            <div className="navbar-header">
                                <button type="button" className="navbar-toggle" data-toggle="collapse" data-target="#navbar-menu">
                                    <i className="fa fa-bars"></i>
                                </button>
                                {/* <Link className="navbar-brand" href="index.html">sine<span>mkt</span>.</Link> */}
                                <Link to='/' onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                                    <img className="navbar-brand" src={logo} alt="" />
                                </Link>

                            </div>{/*/.navbar-header*/}
                            {/* End Header Navigation */}

                            {/* Collect the nav links, forms, and other content for toggling */}
                            <div className="collapse navbar-collapse menu-ui-design " id="navbar-menu" style={{ background: '#f8f9fd', height: '10px' }}>
                                <ul className="nav navbar-nav navbar-center" data-in="fadeInDown" data-out="fadeOutUp">
                                    <li className="menu-list"><Link to="/">home</Link></li>
                                    <li className="menu-list shop" >
                                        <Link to="/collection/all"
                                            onClick={(e) => {
                                                if (window.innerWidth > 576) {
                                                    homeScroll('forshop');
                                                    category.updateCategory("All");
                                                    category.updateSubcategory("All");
                                                    navigate('/collection/all');
                                                }
                                                e.preventDefault()
                                            }}

                                        >shop
                                        </Link>
                                        <ul className='shop-Dropdown' id='shop-Dropdown'>
                                            {collections.map((collection, index) => (
                                                <li key={index} style={{ margin: '5px 0px' }}>

                                                    <span className=""
                                                        onClick={() => {
                                                            homeScroll('forshop');
                                                            category.updateCategory(collection.title);
                                                            category.updateSubcategory("All");
                                                            navigate(`/collection/${slugify(collection.title)}/all`)
                                                        }}
                                                    >{collection.title}</span>
                                                    <i className="fa-solid fa-caret-right pull-right" style={{ marginTop: '7px' }}></i>

                                                    <ul className="items ps-3">
                                                        {collection.categories.map((categoryy, idx) => (
                                                            <li
                                                                key={idx}
                                                                onClick={() => {
                                                                    homeScroll('forshop');
                                                                    category.updateCategory(collection.title);
                                                                    category.updateSubcategory(categoryy);
                                                                }}
                                                            >
                                                                <Link to={`/collection/${slugify(collection.title)}/${slugify(categoryy)}`}>{categoryy}</Link>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </li>
                                            ))}
                                        </ul>
                                    </li>
                                    <li className="menu-list"><Link to="/blog" onClick={() => homeScroll()}>blog</Link></li>
                                    {/* <li className="menu-list"><Link to="/">track Order</Link></li> */}
                                    <li className="menu-list"><Link to="/about" onClick={() => { homeScroll(); }}>about</Link></li>
                                </ul>
                                {/*/.nav */}
                            </div>{/* /.navbar-collapse */}
                        </div>{/*/.container*/}
                    </nav>{/*/nav*/}
                    {/* End Navigation */}
                </div>{/*/.header-area*/}
            </div>{/* /.top-area*/}
            {/* top-area End */}
        </header>
    );
};

export default Header;


// 